import React, { Component } from 'react';
import { 
  Button
} from 'react-bootstrap';

class SignIn extends Component {
  render() {
    return (
      <div>
        <Button 
          bsStyle="primary"
          bsSize="large"
          onClick={() => this.props.authenticate('facebook')}
          block
        >
          Log in with Facebook
        </Button>
        <Button
          bsSize="large"          
          onClick={() => this.props.authenticate('google')}
          disabled
          block
        >
          Log in with Google
        </Button>
        <Button
          bsSize="large"
          onClick={() => this.props.authenticate('github')}
          disabled
          block
        >
          Log in with GitHub
        </Button>
      </div>
    );
  }
}

SignIn.propTypes = {
  authenticate: React.PropTypes.func.isRequired
}

export default SignIn;


// WEBPACK FOOTER //
// ./src/components/SignIn.jsx